import { render } from "./BlockTextQuote.vue?vue&type=template&id=09535c0b&lang=pug"
import script from "./BlockTextQuote.vue?vue&type=script&lang=js"
export * from "./BlockTextQuote.vue?vue&type=script&lang=js"

import "./BlockTextQuote.vue?vue&type=style&index=0&id=09535c0b&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__